import { AddOutlined } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Header } from 'src/components/header/Header'
import { HeaderBackButtonMui } from 'src/components/header/HeaderBackButtonMui'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import Loading from 'src/components/loading/Loading'
import {
  deleteApprovalFlow as deleteApprovalFlowAction,
  getApprovalFlows as getApprovalFlowsAction,
} from 'src/state/ducks/approvalFlows/actions'
import { RootState } from 'src/state/store'
import ApprovalFlowList from './ApprovalFlowList'
import EditApprovalFlowDrawer from './EditApprovalFlowDrawer'

const ApprovalFlowsContainer: React.FC = () => {
  const [isShowEditApprovalFlowDrawer, setIsShowEditApprovalFlowDrawer] =
    useState(false)
  const [isEditingApprovalFlow, setIsEditingApprovalFlow] = useState(false)
  const [editApprovalFlowId, setEditApprovalFlowId] = useState('')

  const dispatch = useDispatch()
  const { approvalFlows, isLoading: isLoadingApprovalFlows } = useSelector(
    (state: RootState) => state.approvalFlowsState.approvalFlows,
  )

  const history = useHistory()

  useEffect(() => {
    dispatch(getApprovalFlowsAction())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickAdd = () => setIsShowEditApprovalFlowDrawer(true)
  const onEdit = (approvalFlowId: string) => {
    setEditApprovalFlowId(approvalFlowId)
    setIsEditingApprovalFlow(true)
    setIsShowEditApprovalFlowDrawer(true)
  }
  const onDelete = (approvalFlowId: string) => {
    dispatch(deleteApprovalFlowAction(approvalFlowId))
  }
  const onClose = () => {
    setIsShowEditApprovalFlowDrawer(false)
    setIsEditingApprovalFlow(false)
  }

  return (
    <Stack sx={{ height: '100%' }}>
      <Header>
        <HeaderBackButtonMui onClick={() => history.goBack()} />
        <HeaderTitle title="承認フロー" />
      </Header>
      <Stack sx={{ flex: 1 }}>
        {isLoadingApprovalFlows ? (
          <Loading />
        ) : (
          <Stack>
            <Stack direction="row" justifyContent="flex-end" p={2}>
              <Button
                variant="contained"
                startIcon={<AddOutlined />}
                onClick={onClickAdd}
              >
                承認フローを追加
              </Button>
            </Stack>
            <ApprovalFlowList
              onEdit={onEdit}
              onDelete={onDelete}
              approvalFlows={approvalFlows}
            />
          </Stack>
        )}
      </Stack>
      <EditApprovalFlowDrawer
        approvalFlowId={editApprovalFlowId}
        isShowDrawer={isShowEditApprovalFlowDrawer}
        isEditing={isEditingApprovalFlow}
        onClose={onClose}
      />
    </Stack>
  )
}

export default ApprovalFlowsContainer
